import { DoqType, ResponsiveDoqWithSpeechBubble } from '@ardoq/doq';
import { EmptyStatesDoqContainer } from '@ardoq/graph';
import { t, type I18nLocale } from '@ardoq/i18n';
import { i18nLocale$ } from 'streams/i18nLocale$';
import { connect } from '@ardoq/rxbeach';
import { map } from 'rxjs';

type NoConnectedComponentsContextDoqProps = {
  doqType: DoqType;
  i18nLocale: I18nLocale;
};

const NoConnectedComponentsContextDoqBase = ({
  doqType,
  i18nLocale,
}: NoConnectedComponentsContextDoqProps) => {
  return (
    <EmptyStatesDoqContainer>
      <ResponsiveDoqWithSpeechBubble
        doqType={doqType}
        title={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noConnectedComponentsContext.title',
          'No connected components'
        )}
        message={t(
          i18nLocale,
          'tabview:graphViews.emptyState.noConnectedComponentsContext.message',
          'Select a component that is connected to other components or select a workspace containing at least one component which is connected to another component.'
        )}
      />
    </EmptyStatesDoqContainer>
  );
};
export const NoConnectedComponentsContextDoq = connect(
  NoConnectedComponentsContextDoqBase,
  i18nLocale$.pipe(map(i18nLocale => ({ i18nLocale })))
);
